/**
 * @copyright © Paramount Streaming
 * @author  Stan Gletski
 * @description Type of player adapter to use.
 * @example
 * // Player adapter is instantiated from the following class reference stored in window.SmartTag.playerAdapter getter
 * const myPlayerAdapter: IPlayerAdapter = new ( window.SmartTag.playerAdapters[ PlayerAdapterType.AVIA ] as IPlayerAdapterConstructor )( { tag: this.tag } as ITagAbstractClassArgument );
 */
export enum PlayerAdapterType {
	/**
	 * @description Avia adapter type
	 * @type {PlayerAdapterType.avia}
	 */
	AVIA = 'avia'
}